import { FeatureFlags } from '../../../common/model/config';

export const onyoComFeatureFlags: FeatureFlags = {
  hideBackButton: true,
};
